import React,{Component} from 'react'
import { Table , Button , Input ,Icon , Drawer, message} from 'antd';
import Highlighter from 'react-highlight-words';
import * as titleActions from '../../../Actions/TitleActions'
import * as employeeActions from '../../../Actions/EmployeeActions'
import EmployeeProfile from './EmployeeProfile'

import employeeStore from '../../../store/EmployeeStore';
import { connect } from 'react-redux';
import axios from 'axios';
import { fetchEmployees } from '../../../redux/employee/actions/actionCreators';



class ViewEmpoloyees extends Component{
    

    state = {
        searchText: '',
        data: [],
        drawer_visible:false,
        EmployeeID : null,
        employees:[]
        // pagination: {},
        // loading: false,
    };


    formatTableData = ()=> {
        console.log(this.props)
        return   this.props.employee.employees.map(
            (employee) => {
                return {
                    key: employee.id,
                    nic: employee.NIC,
                    emp_code : employee.emp_code,
                    name: employee.Contact.FirstName + " " + employee.Contact.LastName,
                    Contact: employee.Contact.ContactNo,
                    address:    employee.Contact.Address.No + "," +
                                employee.Contact.Address.Street + ',' + 
                                employee.Contact.Address.Town,
                    view_employee:employee.id
        
                }
            }
        )    
    }

    componentDidMount(){
        titleActions.changeTitle("Employees")  
        message.loading("Loading employees...")
        this.props.fetchEmployees(
          ()=>{
            message.destroy()
            message.success("Loading Successfull")
          }
          ,
          ()=>{
            message.destroy()
            message.error("Loading failed!")
          }
        )
        // this.fetchEmployees(()=>{
        //   message.destroy()
        //   message.success("Success!")
        // }
        // ,
        // ()=>{
        //   message.error("OOPS! Something went wrong, check your internet connection")
        // })    
    }

    fetchEmployees = (successCallback,errorCallback) => {
      axios.get(`${this.props.server}/user/get-all-employees/`,{headers:{Authorization:`Token ${this.props.token}`}})
      .then(
        response => {
          this.setState({
            employees : response.data
          })
          successCallback()
        }
      )
      .catch(
        error => {
          console.error(error)
          errorCallback()
        }
      )
    }
   

    
      getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <Input
              ref={node => {
                this.searchInput = node;
              }}
              placeholder={`Search ${dataIndex}`}
              value={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
              style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Button
              type="primary"
              onClick={() => this.handleSearch(selectedKeys, confirm)}
              icon="search"
              size="small"
              style={{ width: 90, marginRight: 8 }}
            >
              Search
            </Button>
            <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
          </div>
        ),
        filterIcon: filtered => (
          <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
          record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => this.searchInput.select());
          }
        },
        render: text => (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[this.state.searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ),
      });
    
      handleSearch = (selectedKeys, confirm) => {
        confirm();
        this.setState({ searchText: selectedKeys[0] });
      };
    
      handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
      };
    
    
      
    showDrawer = (event) =>{
        var state = {...this.state}
        state.drawer_visible = true
        state.EmployeeID=parseInt(event.target.id)       
        this.setState(state,()=>console.log(this.state))

    }    
    
    onClose = () => {
        var state = {...this.state}
        state.drawer_visible = false
        this.setState(state)
    }

    

    columns = [
        {
          title: 'Employee Code',
          dataIndex: 'emp_code',
          key: 'emp_code',
          render: text => <span>{text}</span>,
          ...this.getColumnSearchProps('emp_code')
        },
        {
          title: 'NIC',
          dataIndex: 'nic',
          key: 'nic',
          render: text => <span>{text}</span>,
          ...this.getColumnSearchProps('nic')
        },
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
          ...this.getColumnSearchProps('name')
        },
        {
            title: 'Contact No',
            dataIndex: 'Contact',
            key: 'Contact',
          },   
        {
          title: 'Address',
          dataIndex: 'address',
          key: 'address',
        },  
        {
            title: '',
            dataIndex: 'view_employee',
            key: 'view_employee',
            render: id => <Button type="primary" icon="user" onClick={this.showDrawer} id={id}>View</Button>,
          },   
      ];

    render(){
        return (
          <div>
            <Table columns={this.columns} pagination={{ pageSize: 10 }}  dataSource={this.formatTableData()} size="small" /> 
            <Drawer
                title="Employee Details"
                placement="right"
                width= {600}
                destroyOnClose
                closable={true}
                onClose={this.onClose}
                visible={this.state.drawer_visible}
              >
              <EmployeeProfile {...this.props} EmployeeID={this.state.EmployeeID}/>
          </Drawer>
          </div>
        )
    }
}

const mapStateToProps = state => ({
  token : state.auth.authData.token,
  server : state.entity.server,
  employee : state.employee
})

const mapDispatchToProps = dispatch => ({
  fetchEmployees : (successCallback,errorCallback) => dispatch(fetchEmployees(successCallback,errorCallback))
})

export default connect(mapStateToProps,mapDispatchToProps)(ViewEmpoloyees);